import React from "react";
import { Box, Typography } from "@mui/material";

export const InfoRow: React.FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
      py: 1.5,
      borderBottom: "1px solid var(--stroke-secondary-stroke, #E6EDF2)",
    }}
  >
    <Typography variant="body2" color="text.secondary" sx={{ width: "45%", flexShrink: 0 }}>
      {label}
    </Typography>
    <Box sx={{ flex: 1 }}>{children}</Box>
  </Box>
);

export const InfoValue: React.FC<{ testId: string; children: React.ReactNode }> = ({
  testId,
  children,
}) => (
  <Typography variant="body2" color="text.primary" fontWeight={500} data-testid={testId}>
    {children}
  </Typography>
);
